<template>
  <v-form
    ref="form"
    v-model="valid"
    :lazy-validation="lazy">
    <v-card
      flat
      color="transparent">
      <v-card-title class="font-weight-bold q-message">{{ `${qNumber}. ${qMessage}` }}</v-card-title>
      <span
        v-if="qId === '재무-기대근로소득' || qId === '재무-연금화자산'"
        class="pl-10 text-h6 font-italic"
        >{{ `(주직장 퇴직 ${me.retire}세)` }}</span
      >
      <span
        v-if="qId === '재무-연금준비상황2' && !hasWife"
        class="pl-10 text-h6 font-italic font-weight-black"
        >{{ `(해당사항 없음)` }}</span
      >
      <v-container
        class="pt-2 pl-10"
        id="multi-container">
        <v-row v-if="qType === 'multi3'">
          <v-col
            class="headline d-flex align-center"
            cols="4">
            <div>{{ qOption.text }}</div>
          </v-col>
          <v-col
            cols="4"
            class="d-flex align-center">
            <v-select
              class="mx-4"
              :items="headCount"
              v-model="preCount"
              :label="qCategory === 'Career' ? `${qOption.unit}` : `${qOption.unit} 선택`"></v-select>
            <!-- <v-text-field
              dense
              single-line
              class="mx-5"
              v-model="preCount"
              :rules="getRule(qOption.inputType)"
              :placeholder="qCategory === 'Career' ? `${qOption.unit}` : `${qOption.unit} 입력`"
              :suffix="qOption.suffix"
            /> -->
          </v-col>
        </v-row>
        <v-row
          v-for="(q, i) in list"
          :key="q.text"
          style="height: 60px">
          <v-col
            class="d-flex align-center"
            :cols="qCategory === 'Career' ? 1 : qType === 'multi2' ? 3 : 4">
            <div style="font-size: 18px; transform: translateY(-5px)">
              {{ `${splitText(q.text)[1]} ${qNumber === '2-3' ? '(만 ' + (currentYear - children[i].birthAt) + '세)' : qNumber === '2-4' ? `(${currentYear - parents[i].birthAt}세)` : ''}` }}
              <br />
              <span>{{ splitText(q.text)[0] ? splitText(q.text)[2] : '' }}</span>
            </div>
          </v-col>
          <v-col
            :cols="qCategory === 'Career' ? 8 : 3"
            class="d-flex align-center">
            <v-switch
              v-model="answer[i]"
              v-if="q.type === 'toggle'">
              <template v-slot:label>{{ answer[i] ? '가입' : '미가입' }}</template>
            </v-switch>
            <v-text-field
              v-else
              dense
              single-line
              class="mx-5"
              v-model="answer[i]"
              :rules="addRule(getRule(q.inputType, i), q.min ? (v) => v >= q.min || `${q.min} 이상 입력해주세요` : '', q.max ? (v) => v <= q.max || `${q.max} 이하 입력해주세요` : '')"
              :placeholder="`${q.unit} ${qCategory === 'Career' ? '' : '입력'}`"
              :suffix="q.suffix"
              @keyup.enter="confirm" />
          </v-col>
          <v-col
            cols="3"
            v-if="q.notRequired">
            <v-switch
              v-model="isSkipped[i]"
              :label="q.notRequiredTxt"></v-switch>
          </v-col>
          <v-col
            v-if="qType === 'multi2'"
            cols="3">
            <v-text-field
              dense
              single-line
              class="mx-5"
              v-model="answer2[i]"
              :rules="emailType ? [rules.required, rules.emailRules] : [rules.required]"
              :placeholder="`${q.unit2} 입력`"
              required
              :suffix="q.suffix2"
              @keyup.enter="confirm" />
          </v-col>
          <v-col
            v-if="qType === 'multi2' && (q.unit3 || '').length > 0"
            cols="3">
            <v-text-field
              dense
              single-line
              class="mx-5"
              v-model="answer3[i]"
              :rules="emailType ? [rules.required, rules.emailRules] : [rules.required]"
              :placeholder="`${q.unit3} 입력`"
              required
              :suffix="q.suffix3"
              @keyup.enter="confirm" />
          </v-col>
          <!-- <v-col class="headline pt-5">{{ q.unit }}</v-col> -->
        </v-row>
      </v-container>
    </v-card>
    <v-card-actions>
      <v-btn
        color="#5878b8"
        :disabled="isDisable"
        width="100"
        class="headline white--text"
        @click="confirm">
        확인
        <v-icon right>mdi-check</v-icon>
      </v-btn>
      <!-- <v-btn text color="grey" class="title" v-if="valid">
        Enter 키를 눌러주세요
        <v-icon>mdi-keyboard-return</v-icon>
      </v-btn> -->
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
export default {
  props: {
    qType: { type: String, default: '' },
    qCategory: { type: String, default: '' },
    target: {
      type: String,
      default: 'I',
    },
    qOption: {
      type: Object,
      default: () => {},
    },
    qList: {
      type: Array,
      default: () => [],
    },
    qId: {
      type: String,
      default: '',
    },
    qNumber: {
      type: String,
      default: 'qNumber',
    },
    qMessage: {
      type: String,
      default: '',
    },
    qTitle: {
      type: String,
      default: '',
    },
    qPredicate: {
      type: String,
      default: '',
    },
    emailType: {
      type: Boolean,
      default: false,
    },
    maxText: {
      type: Number,
      default: 10,
    },
  },
  mounted() {
    const ans = (this[this.qCategory.toLowerCase()] || {})[this.qId]
    // console.log(ans)
    if (ans) {
      // console.log(ans)

      const ansValueList = ans.value.map(({ value }) => value)
      const ansIsSkippedList = ans.value.map(({ isSkipped }) => isSkipped)

      if (this.qType === 'multi' || this.qType === 'multi3') {
        this.answer = ansValueList
        this.isSkipped = ansIsSkippedList
        this.preCount = ans.option.count
      } else {
        // console.log(ansValueList)

        this.answer = ansValueList.map((k) => k[0])
        this.answer2 = ansValueList.map((k) => k[1])
        this.answer3 = ansValueList.map((k) => k[2])

        // console.log(this.answer, this.answer2)
        // else return { title: o.text, value: [this.answer[i], this.answer2[i], this.answer3[i]] }
      }

      this.isCompleted = true
    }
  },
  data() {
    return {
      valid: true,
      headCount: [0, 1, 2, 3, 4],
      preCount: 0,
      value: undefined,
      isSkipped: [false, false, false, false, false, false, false],
      answer: [],
      answer2: [],
      answer3: [],
      lazy: false,
      rules: {
        required: (value) => !!value || '꼭 써주셔야 합니다',
        counter: (value) => value.length <= 20 || '최대 20 글자까지 해주세요',
        emailRules: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
    }
  },
  methods: {
    ...mapMutations(['setUserEmail', 'setUserNick', 'setMaster', 'setFinance', 'setLife', 'setCareer']),
    ...mapActions(['submit']),

    addRule(fns, ...args) {
      args.filter((k) => k).forEach((k) => fns.push(k))
      console.log(args, fns)
      return fns
    },
    getRule(inputType, idx) {
      const yearRegx = /^(19|20)[0-9]{2}$/
      const ageRegx = /^\d{2}$/
      const childRegx = /^[0-5]$/
      const emailRegx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      let val = []
      switch (inputType) {
        case 'year':
          val.push((v) => yearRegx.test(v) || '연도를 입력하세요')
          break
        case 'age':
          val.push((v) => ageRegx.test(v) || '나이를 입력하세요')
          break
        case 'children':
          val.push((v) => yearRegx.test(v) || '연도를 입력하세요')
          if (idx > 0) {
            val.push((v) => this.answer[idx - 1] < this.answer[idx] || '자녀의 생년을 잘못 입력하셨습니다')
          }
          break
        default:
          return this.emailType ? [this.rules.required, this.rules.emailRules] : [this.rules.required]
      }
      return val
    },
    splitText(txt) {
      const m = txt.split(/:/)
      if (m.length > 1) return [true, m[0], m[1]]
      else return [false, txt]
    },
    getRetireAge() {
      return this.getExit.filter((v) => v.name === '은퇴')[0].age
    },
    confirm() {
      this.$emit('nextSlide')
      const payload = {
        id: this.qId,
        question: this.qMessage,
        category: this.qCategory,
        type: this.qType,
        target: this.target,
        option: {
          count: this.preCount,
        },
        value: this.qList.map((o, i) => {
          if (this.qType === 'multi' || this.qType === 'multi3') return { text: o.text, unit: o.unit, suffix: o.suffix, value: this.answer[i], isSkipped: this.isSkipped[i] || false }
          else return { title: o.text, value: [this.answer[i], this.answer2[i], this.answer3[i]] }
        }),
      }
      if (this.qCategory === 'Master') this.setMaster(payload)
      else if (this.qCategory === 'Finance') this.setFinance(payload)
      else if (this.qCategory === 'Life') this.setLife(payload)
      else if (this.qCategory === 'Career') this.setCareer(payload)
      this.submit()
    },
  },
  computed: {
    ...mapState(['userEmail', 'userNick', 'master', 'children', 'currentYear', 'parents', 'me', 'life', 'finance', 'career', 'action']),
    ...mapGetters(['getExit', 'getFinanceGoalMoney', 'hasWife', 'getChildrenCount', 'getParentsCount', 'getExit']),
    list() {
      if ((this.qOption || {}).type === 'condition') {
        let count = 0
        if (this.qOption.key === 'childrenCount') count = this.getChildrenCount
        if (this.qOption.key === 'parentsCount') count = this.getParentsCount
        if (this.qOption.key === 'hasWife') count = this.hasWife ? 2 : 1
        return this.qList.slice(0, count)
      }
      if (this.qType === 'multi3') return this.qList.slice(0, this.preCount > 5 ? 5 : this.preCount)

      return this.qList
    },
    isDisable() {
      if (this.qId === '재무-연금준비상황2' && !this.hasWife) return false
      else if (!this.valid && this.isSkipped.filter((k) => k).length === 0) return true
      else return false
    },
  },
}
</script>

<style>
#multi-container div.col {
  padding: 8px !important;
}
</style>
